import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * 表单项基础类, 所有输入组件都继承Base
 * @module $ui/components/my-form/src/Base
 */

import { FormItem } from 'element-ui';
import { setStyle } from 'element-ui/lib/utils/dom';
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event';
import { cloneDeep, isEqual } from '@/utils/util';
var _get = require('lodash/get');
var _set = require('lodash/set');

/**
 * 插槽
 * @member slots
 * @property {string} before 输入组件前面的内容，仅当父组件是MyForm有效
 * @property {string} after 输入组件后面的内容，仅当父组件是MyForm有效
 * @property {string} label 定义字段的label内容，仅当父组件是MyForm有效
 * @property {string} error 作用域插槽，定义验证错误提示内容，仅当父组件是MyForm有效
 */

export default {
  inject: {
    myForm: {
      default: null
    }
  },
  components: {
    FormItem: FormItem
  },
  /**
   * 属性参数
   * @member props
   * @property {string} [name] 表单域 model 字段名称, 等价于 el-form-item 的 prop 参数
   * @property {string} [width] 宽度，css属性，支持像素，百分比和表达式，也可以在MyForm中统一设置itemWidth
   * @property {object} [props] 输入组件参数对象，即 element 组件的参数
   * @property {Array} [options] 选项数据，数据优先顺序，options > loader > form.dictMap > form.loader
   * @property {Object} [keyMap] 选项数据对象属性名称映射, 默认：{id, parentId, label, value}
   * @property {boolean} [collapsible] 可收起
   * @property {boolean} [stopEnterEvent] 阻止回车事件冒泡
   * @property {string} [depend] 依赖字段名称
   * @property {*} [dependValue] 依赖字段的值，即依赖字段的值等于该值才会显示
   * @property {string} [cascade] 级联的上级字段名称，需要与loader配合加载数据
   * @property {Function} [loader] 加载数据函数,必须返回Promise
   * @property {string} [dict] 字典名称，只是标识，需要与loader配合 或 表单的dictMap加载数据
   * @property {boolean} [disabled] 禁用
   * @property {boolean} [readonly] 只读
   * @property {string} [placeholder] 占位文本
   *
   */
  props: {
    // 表单域 model 字段名称
    name: String,
    // 宽度，支持像素，百分比和表达式
    width: String,
    // 输入组件参数对象
    props: Object,
    // 选项数据，数据优先顺序，options > loader > form.dictMap > form.loader
    options: Array,
    // 选项数据对象属性名称映射
    keyMap: {
      type: Object,
      default: function _default() {
        return {
          id: 'id',
          label: 'label',
          value: 'value',
          disabled: 'disabled',
          parentId: 'parentId'
        };
      }
    },
    // 可折叠
    collapsible: Boolean,
    // 阻止回车事件冒泡
    stopEnterEvent: Boolean,
    // 依赖字段名称
    depend: String,
    // 依赖字段的值，即依赖字段的值等于该值才会显示
    dependValue: [String, Number, Boolean, Object, Array, Function],
    // 级联的上级字段名称，需要与loader配合加载数据
    cascade: String,
    // 加载数据函数,必须返回Promise
    loader: Function,
    // 字典名称，只是标识，需要与loader配合 或 表单的dictMap加载数据
    dict: String,
    // 禁用
    disabled: Boolean,
    // 只读
    readonly: Boolean,
    // 占位文本
    placeholder: String,
    // 尺寸
    size: String
  },
  data: function data() {
    return {
      // 级联的值缓存
      cascadeValue: null,
      // 当前选项数据
      currentOptions: [],
      // 正在调用loader
      loading: false
    };
  },
  computed: {
    // 如果有name参数，并且是MyForm的子组件，即与MyForm的currentModel作双向绑定
    // 否则与组件自身的value作双向绑定
    fieldValue: {
      get: function get() {
        if (this.name && this.myForm) {
          var currentModel = this.myForm.currentModel;
          return _get(currentModel, this.name, this.getDefaultValue());
        } else {
          return this.value || this.getDefaultValue();
        }
      },
      set: function set(val) {
        if (this.name && this.myForm) {
          var currentModel = this.myForm.currentModel;
          var model = cloneDeep(currentModel);
          _set(model, this.name, val);
          if (!isEqual(currentModel, model)) {
            this.myForm.currentModel[this.name] = model[this.name];
            this.myForm.currentModel = model;
          }
        } else {
          this.$emit('input', val);
        }
      }
    },
    // 字段域的宽度
    itemWidth: function itemWidth() {
      // 优先取自身设置的宽度，没有就取父组件设置的公共设置宽度
      return this.width || (this.myForm && this.myForm.itemWidth ? this.myForm.itemWidth : null);
    },
    // 字段域样式
    itemStyle: function itemStyle() {
      return {
        width: this.itemWidth
      };
    },
    // 输入框组件参数
    innerProps: function innerProps() {
      return _objectSpread({
        disabled: this.disabled,
        readonly: this.readonly,
        placeholder: this.placeholder,
        size: this.size
      }, this.props);
    }
  },
  watch: {
    itemWidth: {
      immediate: true,
      handler: function handler() {
        var _this = this;
        this.$nextTick(function () {
          _this.setContentWidth();
        });
      }
    },
    'myForm.currentCollapsed': function myFormCurrentCollapsed(val) {
      var _this2 = this;
      var _this$myForm = this.myForm,
        resetCollapsed = _this$myForm.resetCollapsed,
        model = _this$myForm.model;
      // 收起时重置表单项值
      if (val && resetCollapsed && model && this.collapsible) {
        this.$nextTick(function () {
          // this.fieldValue = this.myForm.model[this.name]
          _this2.fieldValue = _get(_this2.myForm.model, _this2.name, _this2.getDefaultValue());
        });
      }
      // 开启了折叠功能
      if (this.collapsible) {
        // 折叠时先要清除事件句柄，因为原先的dom即将发生改变
        if (val) {
          removeResizeListener(this.$el, this.setContentWidth);
        } else {
          // 如果没有加载过选项数据，触发加载函数
          if (!this.currentOptions || this.currentOptions.length === 0) {
            this.loadOptions(this.myForm.currentModel, this);
          }
          // 展开时，待DOM生成后，重新注册事件句柄
          this.$nextTick(function () {
            addResizeListener(_this2.$el, _this2.setContentWidth);
            _this2.setContentWidth();
          });
        }
      }
    },
    // options 为了提高性能，不设置deep
    options: {
      immediate: true,
      handler: function handler(val) {
        var _this3 = this;
        this.currentOptions = cloneDeep(val) || [];
        // options改变后，会触发表单验证，这里需要清楚验证错误信息
        this.$nextTick(function () {
          _this3.clearValidate();
        });
      }
    }
  },
  mounted: function mounted() {
    addResizeListener(this.$el, this.setContentWidth);
  },
  created: function created() {
    var model = null;
    if (this.myForm) {
      this.myForm.addItem(this);
      model = this.myForm.currentModel;
    }
    this.loadOptions(model, this);
    this.bindCascade();
  },
  beforeDestroy: function beforeDestroy() {
    removeResizeListener(this.$el, this.setContentWidth);
    this.unbindCascade();
    if (this.myForm) {
      this.myForm.removeItem(this);
    }
  },
  methods: {
    // 获取表单项的默认值，不同组件有不同的默认值，可在具体的组件重写这个函数
    getDefaultValue: function getDefaultValue() {
      return '';
    },
    // 重置字段
    resetField: function resetField() {
      this.$refs.elItem && this.$refs.elItem.resetField();
    },
    // 清除验证错误信息
    clearValidate: function clearValidate() {
      this.$refs.elItem && this.$refs.elItem.clearValidate();
    },
    isCollapsed: function isCollapsed() {
      if (!this.myForm) return false;
      var _this$myForm2 = this.myForm,
        collapsible = _this$myForm2.collapsible,
        currentCollapsed = _this$myForm2.currentCollapsed;
      // 是否已收起
      return collapsible && currentCollapsed && this.collapsible;
    },
    isMatchDepend: function isMatchDepend() {
      // 没有设置依赖，即忽略，当已匹配处理
      if (!this.depend || !this.myForm) return true;
      var model = this.myForm.currentModel;
      // 依赖不支持 按路径查找
      var value = model[this.depend];
      var isMatch = true;
      // 如果 dependValue 是函数，执行回调函数返回布尔值
      if (typeof this.dependValue === 'function') {
        isMatch = this.dependValue(value, model, this);
      } else {
        // 以上都不符合，即检验 dependValue 与 currentModel中的依赖属性是否一致
        isMatch = isEqual(this.dependValue, value);
      }

      // 清除依赖不符合字段的值
      if (!isMatch && this.name && model[this.name]) {
        this.fieldValue = this.getDefaultValue();
        delete model[this.name];
      }
      return isMatch;
    },
    // 传递给输入组件的插槽
    createSlots: function createSlots() {
      var _this4 = this;
      var slots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var h = this.$createElement;
      return slots.map(function (name) {
        return h("template", {
          "slot": name
        }, [_this4.$slots[name]]);
      });
    },
    // 继承输入组件暴露的方法
    extendMethods: function extendMethods(ref) {
      var _this5 = this;
      var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!ref) return;
      names.forEach(function (name) {
        // 子组件的方法加到实例
        _this5[name] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          ref[name].apply(ref, args);
        };
      });
    },
    // 设置el-form-item内部的内容区宽度
    setContentWidth: function setContentWidth() {
      // 字段域没有设置宽度，默认自适应，不需要处理
      if (!this.itemWidth || !this.$el) return;
      var content = this.$el.querySelector('.el-form-item__content');
      var label = this.$el.querySelector('.el-form-item__label');
      if (content) {
        var rect = label ? label.getBoundingClientRect() : {
          width: 0
        };
        var itemWidth = this.$el.getBoundingClientRect().width;
        var contentWidth = itemWidth - rect.width;
        setStyle(content, {
          width: "".concat(contentWidth, "px")
        });
      }
    },
    // 阻止回车事件冒泡
    stopEvent: function stopEvent(e) {
      if (this.stopEnterEvent) {
        e.stopPropagation();
      }
    },
    // 加载选项数据
    loadOptions: function loadOptions(model) {
      var _this6 = this;
      // 已收起的，不需要处理
      if (this.isCollapsed()) return;

      // 如果不符合依赖，不处理
      if (!this.isMatchDepend()) return;

      // 数据优先顺序，options > loader > form.dictMap > form.loader
      if (this.options) {
        this.currentOptions = cloneDeep(this.options);
        return;
      }
      if (this.loader) {
        this.loading = true;
        this.loader(model, this).then(function (res) {
          _this6.currentOptions = cloneDeep(res);
        }).finally(function () {
          _this6.loading = false;
        });
        return;
      }

      // 无form容器，终止
      if (!this.myForm) return;
      if (this.dict) {
        var dictMap = this.myForm.dictMap;
        var options = (dictMap || {})[this.dict];
        // 建立与表单的字典数据引用
        if (options) {
          this.currentOptions = options;
          return;
        }
      }
      if (this.myForm.loader) {
        this.loading = true;
        this.myForm.loader(model, this).then(function (res) {
          _this6.currentOptions = cloneDeep(res);
        }).finally(function () {
          _this6.loading = false;
        });
      }
    },
    // 响应currentModel改变处理级联加载数据
    handleWatch: function handleWatch(model) {
      // 级联上级的值
      var val = model[this.cascade];
      // 与上次的值不一致即重新获取数据
      if (!isEqual(this.cascadeValue, val)) {
        this.fieldValue = this.getDefaultValue();
        this.cascadeValue = val;
        this.loadOptions(model);
      }
    },
    // 绑定级联
    bindCascade: function bindCascade() {
      if (this.cascade && this.myForm) {
        var model = this.myForm.currentModel;
        this.cascadeValue = model[this.cascade];
        this.unwatch = this.$watch('myForm.currentModel', this.handleWatch, {
          deep: true
        });
      }
    },
    // 销毁级联事件句柄
    unbindCascade: function unbindCascade() {
      this.unwatch && this.unwatch();
    },
    // 渲染输入组件
    renderComponent: function renderComponent(vnode) {
      var _this7 = this;
      var h = this.$createElement;
      // 如果组件不是MyForm的子组件，不需要包裹Item组件
      if (!this.myForm) {
        return vnode;
      }
      // el-form-item 作用域插槽
      var scopedSlots = this.$scopedSlots.error ? {
        error: function error(props) {
          return h("div", {
            "class": 'el-form-item__error my-from__custom-error'
          }, [_this7.$scopedSlots.error(props)]);
        }
      } : null;

      // 是否已收起
      var collapsed = this.isCollapsed();
      // 是否符合依赖项
      var isMatched = this.isMatchDepend();
      return h("transition", {
        "attrs": {
          "name": this.myForm.collapseEffect
        }
      }, [!collapsed && isMatched ? h(FormItem, _mergeJSXProps([{
        "ref": 'elItem',
        "class": 'my-form-item'
      }, {
        props: this.$attrs,
        scopedSlots: scopedSlots,
        style: this.itemStyle
      }, {
        "attrs": {
          "prop": this.name
        },
        "nativeOn": {
          "keyup": function keyup($event) {
            if (!("button" in $event) && _this7._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
            return _this7.stopEvent($event);
          }
        }
      }]), [
      // label 插槽
      this.$slots.label ? h("template", {
        "slot": 'label'
      }, [this.$slots.label]) : null, this.$slots.before, vnode, this.$slots.after]) // Vue组件必须要有一个根DOM，创建一个隐藏占位元素
      : h("div", {
        "style": {
          display: 'none'
        }
      }, [this.name])]);
    }
  }
};